import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { MatModule } from '../../core/mat.module';
import { MatDrawer, MatSidenav } from '@angular/material/sidenav';
import { RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { LoginComponent } from '../../core/authentication/components/login/login.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { StorageService } from '../../services/storage.service';
import { UserService } from '../../services/user.service';
import { JoinComponent } from '../../core/authentication/components/join/join.component';
import { Overlay } from '@angular/cdk/overlay';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
  @ViewChild('sidenav') sidenav: MatSidenav;
  readonly dialog = inject(MatDialog);
  isMenuOpen: boolean;
  constructor(
    private router: Router,
    private userService: UserService,
    private storageService: StorageService,
    private overlay: Overlay
  ) { }

  ngOnInit(): void {
    this.userService.redirectToDashboard();
    this.loadRecaptchaScript()
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  openDialog() {
    const dialogRef = this.dialog.open(LoginComponent, {
      id: 'loginCustomDialog',
      panelClass: 'custom-login-dialog-container',
      scrollStrategy: this.overlay.scrollStrategies.noop(),
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
  });
  }

  getJoinNow() {
    const referralCode = this.storageService.getSessionItem("referralCode")
    const affiliateUrl = this.storageService.getSessionItem("_affiliateUrl");
    if (referralCode && referralCode !== "undefined") {
      this.router.navigate([`/create-account/${referralCode}`]);
    } else if (affiliateUrl && affiliateUrl !== "undefined") {
      this.router.navigate(['/create-account'], { queryParams: this.parseQueryParams(affiliateUrl) });
    } else {
      this.router.navigate(['/']);
    }
  }

  private parseQueryParams(queryString: string): Record<string, string> {
    return queryString.split('&').reduce((params, pair) => {
      const [key, value] = pair.split('=');
      params[key] = decodeURIComponent(value || '');
      return params;
    }, {} as Record<string, string>);
  }

  openJoinModal() {
    this.dialog.open(JoinComponent, {
      panelClass: 'custom-dialog-container',
      id: 'joinCustomDialog',
      scrollStrategy: this.overlay.scrollStrategies.noop(),
      disableClose: true
    });
  }

  loadRecaptchaScript(): Promise<void> {
    return new Promise(resolve => {
      const script = document.createElement('script');
      script.src = 'https://www.google.com/recaptcha/api.js';
      script.async = true;
      script.defer = true;
      script.onload = () => resolve();
      document.head.appendChild(script);
    });
  }
}
